
export const ASSESSMENT = '/assessment/'
export const ASSESSMENT_FORMATIVE = `${ASSESSMENT}formative/` as const
